import { IPortalScoreItem } from '../../interfaces/property';

interface IAction {
    type: string,
    payload?: IPortalScoreItem
}

const DEFAULT_STATE: IPortalScoreItem = {
    OrgScores: [],
    TotalOrgProfileScore: 0,
    OrgFacilityCount: 0,
    PropertyScores: []
};

export default (state = DEFAULT_STATE, action: IAction) => {
    switch (action.type) {
        case 'SET_PROFILE_COMPLETENESS':
            state = {
                ...state,
                ...action.payload
            };
            break;
    }

    return state;
};
